import { render, staticRenderFns } from "./cart-drawer-upsell-item.vue?vue&type=template&id=505319e8&"
import script from "./cart-drawer-upsell-item.vue?vue&type=script&lang=js&"
export * from "./cart-drawer-upsell-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports